import { Popover } from '@mui/material';
import EmojiPickerReact, { EmojiStyle } from 'emoji-picker-react';
import React, { useMemo } from 'react';
import IconButton from 'ui/elements/icons/IconButton';
import SmileyIcon from 'ui/elements/icons/SmileyIcon';

interface Props {
  onSelect: (emoji: string) => void;
  value?: string;
  style?: React.CSSProperties;
}

export default function EmojiPicker({ onSelect, value, style }: Props) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  function handleClose() {
    setAnchorEl(null);
  }

  function handleClick(e: React.MouseEvent<HTMLElement>) {
    setAnchorEl(anchorEl ? null : e.currentTarget);
  }

  const component = useMemo(
    () => (
      <EmojiPickerReact
        emojiStyle={EmojiStyle.NATIVE}
        onEmojiClick={emoji => {
          handleClose();
          onSelect(emoji.emoji);
        }}
      />
    ),
    [onSelect],
  );

  return (
    <div style={style}>
      <IconButton size="small" color="indigo" onClick={handleClick}>
        {value ? <div>{value}</div> : <SmileyIcon />}
      </IconButton>

      <Popover
        transitionDuration={150}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        {component}
      </Popover>
    </div>
  );
}
